import { BalanceResultEntity } from "../../domain/entities/balance_result_entity"
import http from "../../../../plugins/http-common"

export const HttpBalanceRepository = {
  model: BalanceResultEntity,

  async get_balance_v4(initial_date, final_date) {
    const res = await http.get('getBalanceV4/' + initial_date + '/' + final_date);

    return res;
  }
};